import React from "react";
import CssBaseline from "@mui/material/CssBaseline";
import Box from "@mui/material/Box";
import {Typography} from "@mui/material";
import Grid from "@mui/material/Grid";
import DialogButtonRegistration from "../../components/DialogButtonRegistration/DialogButtonRegistration";

const ServicePage: React.FC = () => {

    return(
        <>
            <CssBaseline />
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    minHeight: '80vh',
                }}
            >
                <Box sx={{ maxWidth: 800, margin: '0 auto', padding: 2 }}>
                    <Grid container spacing={{ xs: 2, md: 3 }}>
                        <Grid item xs={12} sm={12} md={6} lg={6} xl={6}  >
                            <Typography variant="h2" gutterBottom>
                                Услуга
                            </Typography>
                        </Grid>
                        <Grid item xs={12} sm={12} md={6} lg={6} xl={6}  >
                            <DialogButtonRegistration streamName={'service'} />
                        </Grid>
                    </Grid>

                    <Typography
                        variant="body1"
                        paragraph
                        sx={{
                            fontStyle: 'italic',
                            borderLeft: '4px solid #000',
                            paddingLeft: '16px',
                            marginLeft: '16px',
                            color: 'text.secondary',
                        }}
                    >
                        Загадка: этим можно делиться множество раз, а меньше не станет. Что это?
                    </Typography>

                    <Typography variant="body1" paragraph>
                        У фронтов всегда есть возможность взять заказы у частников и делать сайты под заказ.
                    </Typography>

                    <Typography variant="body1" paragraph>
                        В рамках соревнований в ветке "Услуга" - мы будем заниматься поиском такого же рога изобилия - но для инженеров и аналитиков данных.
                    </Typography>

                    <Typography variant="body1" paragraph>
                        Отличается от ветки "Продукт" тем - что "Услуга" - именно про то, чтобы брать частные заказы и получать деньги за их выполнение.
                    </Typography>

                    <div>
                        <Typography variant="body1">
                            В качестве результата нужно будет презентовать:
                        </Typography>
                            <ul>
                                <li>Основную идею, за что планировалось получать деньги.</li>
                                <li>Как искали клиентов.</li>
                                <li>Насколько сильный спрос.</li>
                                <li>Маркетинговые ходы для поиска клиентов.</li>
                                <li>Результаты: удалось ли найти заказы и много ли вообще за это платят.</li>
                            </ul>
                    </div>

                    <Typography variant="body1" paragraph>
                        В идеале хочется найти такой же "Рог изобилия" как сайты от частников для фронтов - чтобы хватило вообще на всех и было нужно всем.
                    </Typography>

                    <Typography variant="body1">
                        Говорят, что бизнес просто тащится, если ему клиентов приводить - может стоит покопать в эту сторону.
                    </Typography>
                    <Typography variant="body1" paragraph>
                        Может даже стоит ради этого привлечь в команду пару маркетологов и продавать результат взаимодействия DA/DE с маркетологом.
                    </Typography>

                    <Typography variant="body1">
                        В общем, приз предусмотрен только за первое место - и его получит тот, кто придумает идею, у которой будет потенциал дать максимальное количество частных заказов для инженеров и/или аналитиков данных.
                    </Typography>
                    <Typography variant="body1" paragraph>
                        Но важна не только сама идея (гипотеза) - но и проверка этой гипотезы - что получилось на практике.
                    </Typography>
                </Box>
            </Box>
        </>
    )
}

export default ServicePage;